import { enhancedApi as generatedTenantsApi } from './tenants'
import { tenantsCacheTags } from './tenantsCacheTags'

// The generator emits no cache tags, so they are applied here rather than patched into
// `tenants.ts`, which the next `pnpm api-generate` would wipe. Import hooks from this module,
// never from `./tenants`, or a chunk that skips this file ships without the tags.

// Each policy key maps onto itself only when it names a generated endpoint, so a regeneration
// rename fails compilation here instead of enhanceEndpoints silently ignoring the policy.
const checkedCacheTags: {
  [K in keyof typeof tenantsCacheTags]: K extends keyof (typeof generatedTenantsApi)['endpoints']
    ? (typeof tenantsCacheTags)[K]
    : never
} = tenantsCacheTags

export const tenantsApi = generatedTenantsApi.enhanceEndpoints({ endpoints: checkedCacheTags })

export const {
  useListTenantsQuery,
  useCreateTenantMutation,
  useDeleteTenantMutation,
  useUpdateTenantMutation,
  useListTenantNotesQuery,
  useCreateTenantNoteMutation,
  useDeleteTenantNoteMutation,
  useUpdateTenantNoteMutation,
  useDeleteAllTenantNotesMutation,
  useGetTenantThemeQuery,
  useUpsertTenantThemeMutation,
  useUpsertTenantLogoMutation,
  useDeleteTenantLogoMutation,
  useGetEmployeeIdConfigQuery,
  useUpsertEmployeeIdConfigMutation,
} = tenantsApi
export const { usePrefetch: useTenantsPrefetch } = tenantsApi
export * from './tenants'
